import React from 'react';
import PremiumDonationPage from './PremiumDonationPage';
import DonationsPageSEO from './DonationsPageSEO';
import { reportError } from '../utils/errorHandling';

/**
 * EnhancedDonationPage
 * Premium single-page donation experience with 3D hardware selector and optimized conversion flow
 */
function EnhancedDonationPage({ user }) {
    try {
        // Include both the SEO component and the premium single-page donation experience
        return (
            <>
                <DonationsPageSEO />
                <PremiumDonationPage 
                    user={user}
                    onDonationSubmit={(data) => {
                        // This will be handled by the donation service
                        console.log("Donation submitted:", data);
                        return window.donationService?.createDonation?.(data);
                    }}
                />
            </>
        );
    } catch (error) {
        console.error('EnhancedDonationPage error:', error);
        reportError(error);
        return null;
    }
}

export default EnhancedDonationPage;
